import { HttpErrorResponse } from '@angular/common/http';
import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { DomSanitizer } from '@angular/platform-browser';
import {  NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { ImageRequest } from '../../../../../models/api-dam/image/image-request.model';
import { ImageResponseGet } from '../../../../../models/api-dam/image/image-response.model';
import { ImageService } from '../../../../../services/api-dam/image/image.service';
import { environment } from '../../../../../../environments/environment';
import { TRUE } from '../../../../../utils/config/const';
import { UtilsService } from '../../../../../services/utils-folder/utils.service';

@Component({
  selector: 'app-immagini-edit',
  templateUrl: './immagini-edit.component.html',
  styleUrls: ['./immagini-edit.component.scss']
})
export class ImmaginiEditComponent implements OnInit {

  @Input() public idImage:number;

  imageModel:ImageRequest;
  imageResponse: ImageResponseGet;
  formBuilder: FormGroup;
  isButtonSaveDisabled:boolean;

  fe_url:string = environment.frontendEnv.url;
  externalLinkPublicUrl:string= "";
  linkPublicUrl:string= "";
  successCopyUrlClass:boolean = false;


  fileUrlDownload:any;

  constructor(
    public activeModal: NgbActiveModal,
    private domSanitizer: DomSanitizer,
    private fb: FormBuilder,
    private imageService:ImageService,
    private toastr: ToastrService,
    private utilsService:UtilsService
  ) {
    this.formBuilder = this.fb.group(new ImageRequest());
    this.imageResponse = new ImageResponseGet();
    this.formBuilder.addControl("publicurl",this.fb.control(''));
    this.formBuilder.controls.publicurl.disable();
    this.formBuilder.controls.filename.disable();
   }

  ngOnInit(): void {
    this.init();
  }


  get form(){return this.formBuilder;}
  get formControls() { return this.formBuilder.controls; }


  init(){
    this.imageModel = new ImageRequest();
    this.imageService.getEntity(this.idImage).subscribe(
      (response) => {
        
        this.imageModel = response;
        this.imageResponse = response;
        this.formBuilder = this.fb.group({
          name: [response.name,[Validators.required]],
          url:response.url,
          publicurl: [{value: response.publicUrl, disabled:true}],
          alt: response.alt,
          summary: response.summary,
          tags: response.tags,
          copyright: response.copyright,
          filename: [{value:response.filename, disabled:true}]
        });

        if(typeof response.publicUrl != typeof undefined){
          if(response.publicUrl != null && response.publicUrl != ""){
            this.externalLinkPublicUrl = this.fe_url + response.publicUrl;
            this.linkPublicUrl = response.publicUrl;
          }
        }
      },
      (error: HttpErrorResponse)=>{
        this.toastr.error('Si è verificato un errore durante il caricamento delle informazioni dell\'immagine' , 'Modifica immagine', {
          timeOut: 5000
        });
      }
    );
  }


 
  clickButtonCopyUrl(){
    if(this.formBuilder.controls['publicurl'].value != null && this.formBuilder.controls['publicurl'].value != ""){
      navigator.clipboard.writeText(this.linkPublicUrl); 
      this.successCopyUrlClass = true;
      const delay = ms => new Promise(res => setTimeout(()=>{this.successCopyUrlClass = false;}, ms));
      delay(5000);
      this.toastr.success('' , 'URL copiato', {
        timeOut: 5000
      });

    }
  }

  setDownloadImage(){
    this.imageService.download(this.idImage).subscribe(
      (response) => {
        let objectURL = URL.createObjectURL(response);
        this.fileUrlDownload = this.utilsService.getSecurityTrustResourceUrl(objectURL);        
      }
    );
  }

 

  /**
   * Azione button conferma
   */
  save(){
    if(this.formBuilder.status === 'VALID'){
      this.imageModel = this.formBuilder.value;
      this.imageService.update(this.idImage,this.imageModel).subscribe(
        (response) => { 
          if(response != null && typeof response != typeof undefined){
            this.toastr.success('Immagine modificata con successo', 'Modifica immagine');
            this.isButtonSaveDisabled = true;
            this.activeModal.close(response);
          }     
        },
        (error: HttpErrorResponse)=>{
          console.log(error);
          this.isButtonSaveDisabled = true;
          this.toastr.error('Si è verificato un errore durante la modifica dell\'immagine' , 'Modifica immagine fallita', {
            timeOut: 5000
          });
        }
      );
    }  
  }

  /**
   * Azione button Annulla
   */
  cancel() {
    this.activeModal.close('CLOSE');
  }

  clickButtonSave(){
    if(this.formBuilder.status === 'VALID' && this.formBuilder.touched == TRUE){
      this.isButtonSaveDisabled = true;
      this.save();
    }
  }
}
